import { Directive, Input } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[max][ngModel]',
  providers: [{provide: NG_VALIDATORS, useExisting: CustomMaxDirective, multi: true}],
  standalone: false,
})
export class CustomMaxDirective implements Validator {
  @Input()
  max: number;

  validate(c: UntypedFormControl): {[key: string]: any} {
      let v = c.value;
      return ( v > this.max)? {"max": true} : null;
  }
}
